import { api, defaultQueriesFor } from '../apiSlice';

export const cmsPageApi = api
  .enhanceEndpoints({ addTagTypes: ['CmsPage'] })
  .injectEndpoints({
    endpoints: build => ({
      // useId = true: CmsPage uses numeric DB id (no friendly_id slug),
      // so updates/deletes route to /cms_pages/:id (the integer).
      ...defaultQueriesFor(build, 'CmsPage', 'CmsPages', true),

      // Public read for the usePageContent hook.
      // Returns { content: null } when no published row exists for this city.
      getCmsPageForPage: build.query({
        query: (pageSlug) => `/cms_pages/for_page/${pageSlug}`,
        providesTags: (result, error, pageSlug) => [{ type: 'CmsPage', id: `for_page:${pageSlug}` }],
      }),
    }),
  });

export const {
  useCreateCmsPageMutation,
  useDeleteCmsPageMutation,
  useGetCmsPageByIdQuery,
  useGetCmsPagesQuery,
  useUpdateCmsPageMutation,
  useGetCmsPageForPageQuery,
} = cmsPageApi;
